// Mirrors how an admin drops into a restaurant dashboard: the row click parks
// the target id in localStorage and routes into that account's own layout.
const readUser = () => {
  try {
    const raw = localStorage.getItem('user-borku')
    return raw ? JSON.parse(raw) : null
  } catch (err) {
    return null
  }
}

// True when someone other than the influencer (an admin/staff) is looking
export const isAdminViewingInfluencer = () => {
  const user = readUser()
  if (!user || user.userType === 'INFLUENCER') return false
  return Boolean(localStorage.getItem('influencerId'))
}

// The id to query for. An influencer reads their own account from their token,
// so this stays null for them even if a stale id is lying around.
export const getViewingInfluencerId = () => {
  const user = readUser()
  if (!user || user.userType === 'INFLUENCER') return null
  return localStorage.getItem('influencerId') || null
}

export const getViewingInfluencerName = () =>
  localStorage.getItem('influencerName') || ''

export const enterInfluencer = influencer => {
  localStorage.setItem('influencerId', influencer._id)
  localStorage.setItem('influencerName', influencer.name || '')
}

export const exitInfluencer = () => {
  localStorage.removeItem('influencerId')
  localStorage.removeItem('influencerName')
}
